<template>
    <div class="container">
        <div class="card pink darken-3">
          <div class="card-content white-text">
            <span class="card-title">See the next level</span>
            <p>Keep it up, {{ name }}! Do you know how closed you are from the next level</p>
          </div>
          <div class="card-action">
            <router-link :to="{name:'Records', params:{tab: 'perf'}}" >
              <span @click="call('targets')"><i class="material-icons">flag</i> Go to Targets</span>
            </router-link>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'trackBodyRemind',
  props: {
    'name': String,
    'callback': Function
  },
  methods: {
    call: function (card) {
      if (this.callback) this.callback(card)
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/cards/TargetsRemind.vue